import { TOAST_STR } from 'src/constant'
import { Academy } from 'src/dto'
import modalService from 'src/service/modal.service'

import { academyController } from '@/controller/academy.controller'
import commonRepo from '@/repository/common.repo'
import { toastError, toastSuccess } from '@/utils/toast'

export default class AcademyOptionsService {
  academy: Academy = new Academy()

  constructor() {
    if (commonRepo.academy) {
      this.academy = commonRepo.academy
    }
  }

  fetchMyAcademy = async () => {
    try {
      this.academy = await academyController.fetchMyAcademy()
      commonRepo.academy?.update(this.academy)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  changeMyAcademy = async (academy: Academy) => {
    try {
      await academyController.changeMyAcademy(academy)
      await this.fetchMyAcademy()
      modalService.closeModal()
      toastSuccess(TOAST_STR.modify)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  modifyAcademyCustomerType = async (customerType: Academy['customerType']) => {
    try {
      await academyController.changeCustomerType({ customerType })
      this.academy.setCustomerType(customerType)
      toastSuccess(TOAST_STR.customerTypeModify)
    } catch (e) {
      toastError(TOAST_STR.errorMessage)
    }
  }
}
